import React from "react";
import { MapPin, CircleChevronDown, RotateCcw } from "lucide-react";

const RegionSelector = ({
  selectedRegion,
  municipalRegions,
  showDropdown,
  onToggleDropdown,
  onSelectRegion,
  onReset,
}) => {
  return (
    <div className="bg-blue-100 text-black p-3 m-1">
      <div className="relative">
        <div
          className="bg-blue-200 rounded-lg px-3 py-2 flex items-center justify-between cursor-pointer hover:bg-blue-300 transition-colors"
          // onClick={() => municipalRegions.length > 1 && onToggleDropdown()}
        >
          <div className="flex items-center space-x-2">
            <MapPin className="w-4 h-4" />
            <span className="text-sm font-medium">
              {selectedRegion?.region_name || "Select City"}
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <RotateCcw
              className="w-4 h-4 hover:rotate-180 transition-transform"
              onClick={(e) => {
                e.stopPropagation();
                onReset();
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegionSelector;
